import { type ReactNode } from 'react';

/**
 * The figures behind a chart, as a table only a screen reader reads. A chart is a picture; this
 * is what it says, so nothing on it is visible to sighted readers alone.
 */
export function ChartTable({
    caption,
    columns,
    rows,
}: {
    caption: string;
    columns: string[];
    rows: { label: string; cells: ReactNode[] }[];
}) {
    // The visually hidden box wraps the table rather than being its class: a table cannot be
    // narrower than its content, so `sr-only` on the table itself still widened a phone's page.
    return (
        <div className="sr-only">
            <table>
                <caption>{caption}</caption>
                <thead>
                    <tr>
                        <th scope="col">{columns[0]}</th>
                        {columns.slice(1).map((column, i) => (
                            <th key={i} scope="col">
                                {column}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, rowIndex) => (
                        // By position: a chart's labels can repeat, as a short range's cut-offs do.
                        <tr key={rowIndex}>
                            <th scope="row">{row.label}</th>
                            {row.cells.map((cell, cellIndex) => (
                                <td key={cellIndex}>{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
